module.exports = __webpack_public_path__ + "img/card-discover.3862cbfe.png";